<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Funções por Pessoa' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid>
    <ion-row *ngFor="let p of pessoas">
      <ion-col class="remove-border">
        <ion-item class="avatar-square">
          <ion-avatar slot="start">
            <img [src]="p.foto | image:' '" />
          </ion-avatar>

          <label>
            <h3 class="item-title">{{p.nome}}</h3>
          </label>
        </ion-item>
      </ion-col>
    </ion-row>
    <div class="linha-vertical"></div>
  </ion-grid>

  <ion-grid *ngIf="funcoesPessoa.length">
    <ion-card>
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-users div-icon" style="margin-top: 2px"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Funções da Pessoa' | translate}} </ion-label>
        </div>
      </div>

      <ion-row *ngFor="let funcao of funcoesPessoa;">
        <ion-col class="item-background remove-border">
          <ion-item>
            <ion-label>
              <h3 class="item-title">{{funcao.funcao}}</h3>
            </ion-label>

            <ion-note slot="end">
              <ion-icon (click)="removerFuncao(funcao);" name="trash-sharp" class="icon-card"></ion-icon>
            </ion-note>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-card>
  </ion-grid>

  <ion-grid>
    <div class="gradient-extendido-div">
      <div class="div-top">
        <i class="fa-solid fa-gears div-icon"></i>
        <ion-label class="color-title"> {{'Funções sem responsável' | translate}} </ion-label>
      </div>
    </div>

    <ion-row size="12">
      <ion-col>
        <ion-searchbar
          class="custom"
          show-cancel-button="never"
          placeholder="{{'Buscar' | translate}}"
          [(ngModel)]="filtro"
          (ionInput)="onInput()"
        >
        </ion-searchbar>
      </ion-col>
    </ion-row>

    <ion-row size="12" *ngFor="let f of funcoesList;">
      <ion-col (click)="!processando && selecionarFuncao(f)" class="remove-border">
        <ion-item>
          <ion-note slot="start">
            <i class="fas fa-users icon-list div-icon" style="margin-top: 2px"></i>
          </ion-note>

          <ion-label>
            <h3>{{f.funcao }}<span *ngIf="f.qtd">({{f.qtdDisponivel}}/{{f.qtd}})</span></h3>
          </ion-label>
        </ion-item>
        <div class="linha-vertical"></div>
      </ion-col>

      <sem-registro [hidden]="funcoesList.length"> </sem-registro>

      <ion-infinite-scroll (ionInfinite)="loadFuncoes($event)" *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-row>
  </ion-grid>
</ion-content>
